import { bootInstance } from "./instance.js";

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".bhgpxv").forEach(bootInstance);
});
